import { defineMessages, FormattedMessage } from 'react-intl';

import { LegacyButton } from '@/components/LegacyButton';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';
import { commonMessages } from '@/messages/common';
import { INTL_PREFIX } from '@/messages/const';

const intlPrefix = INTL_PREFIX.EVENT;

export const eventMessages = defineMessages({
  alreadySubscribed: {
    id: `${intlPrefix}.alreadySubscribed`,
    defaultMessage:
      'You are already subscribed. Stay tuned for updates regarding our 140th anniversary.',
  },
  findModeAndSn: {
    id: `${intlPrefix}.findModeAndSn`,
    defaultMessage: 'Where to find my mode and serial number?',
  },
  extendWarranty: {
    id: `${intlPrefix}.extendWarranty`,
    defaultMessage: 'Extend warranty',
  },
  trySearching: {
    id: `${intlPrefix}.trySearching`,
    defaultMessage: 'Try searching here',
  },
  registerIt: {
    id: `${intlPrefix}.registerIt`,
    defaultMessage: 'Register it',
  },
  warrantyExtensionCheckFailed: {
    id: `${intlPrefix}.warrantyExtensionCheckFailed`,
    defaultMessage: 'Warranty extension eligibility check failed',
  },
});

export const Subscription = (
  <FormattedMessage
    defaultMessage='Subscription'
    id={`${intlPrefix}.subscription`}
  />
);

export const getMyNFTTitle = (
  <FormattedMessage
    defaultMessage='Get my Breitling NFT'
    id='event.getMyNFT.title'
  />
);

export const ScanQrCodeOnWarrantyCard = (
  <FormattedMessage
    defaultMessage='Scan the QR code on warranty card'
    id='event.getMyNFT.scanQrCode'
  />
);

export const getMyNFTDesc = (closeModal: () => void) => (
  <FormattedMessage
    defaultMessage='Please get your blockchain certificate from your mobile device {br} For any questions please do not hesitate to {contactUsLink}'
    id='event.getMyNFT.desc'
    values={{
      br: <br />,
      contactUsLink: (
        <LinkWithLocale href={paths.contact.url()} onClick={closeModal}>
          <FormattedMessage {...commonMessages.contactUs} />
        </LinkWithLocale>
      ),
    }}
  />
);

export const findYourWatchBySearch = (onNavToSearch: () => void) => (
  <FormattedMessage
    defaultMessage="Didn't find your watch on the list? {searchLink}."
    id='event.findYourWatchBySearch'
    values={{
      searchLink: (
        <LegacyButton
          onClick={onNavToSearch}
          style={{ textDecorationColor: 'inherit' }}
          variant='link'
        >
          <FormattedMessage {...eventMessages.trySearching} />
        </LegacyButton>
      ),
    }}
  />
);

export const watchNotFound = (closeModal: () => void) => (
  <FormattedMessage
    defaultMessage='No watch found. For any questions please do not hesitate to {contactUsLink}.'
    id='event.watchNotFound'
    values={{
      contactUsLink: (
        <LinkWithLocale href={paths.contact.url()} onClick={closeModal}>
          <FormattedMessage {...commonMessages.contactUs} />
        </LinkWithLocale>
      ),
    }}
  />
);

export const watchNotRegistered = (closeModal: () => void) => (
  <FormattedMessage
    defaultMessage="Your watch isn't registered. Please {registerLink} first or {contactUsLink} to extend the warranty."
    id='event.watchNotRegistered'
    values={{
      registerLink: (
        <LinkWithLocale
          href={paths.myAccount.myWatches.url()}
          onClick={closeModal}
        >
          <FormattedMessage {...eventMessages.registerIt} />
        </LinkWithLocale>
      ),
      contactUsLink: (
        <LinkWithLocale href={paths.contact.url()} onClick={closeModal}>
          <FormattedMessage {...commonMessages.contactUs} />
        </LinkWithLocale>
      ),
    }}
  />
);

export const watchNotRegisteredToYourAccount = (closeModal: () => void) => (
  <FormattedMessage
    defaultMessage='Watch not registered to your account. Please {contactUsLink} to extend the warranty.'
    id='event.watchNotRegisteredToYourAccount'
    values={{
      contactUsLink: (
        <LinkWithLocale href={paths.contact.url()} onClick={closeModal}>
          <FormattedMessage {...commonMessages.contactUs} />
        </LinkWithLocale>
      ),
    }}
  />
);
